<div class="subcategories-wrapper">
  <a class="subcategory" *ngFor="let subcategory of subcategories" [routerLink]="getLink(subcategory)" routerLinkActive="is-active">
    {{ subcategory | titlecase }}
  </a>
</div>
<img *ngIf="imageUrl" [src]="imageUrl" />
